import angular from "angular";
import uiBootstrap from "angular-ui-bootstrap";
import {NavbarCalculationAlarmComponent} from "./navbar_calculation_alarm.component";

export const NavbarCalculationAlarmModule =
    angular.module('navbar-calculation-alarm-module', [uiBootstrap])
        .component('navbarCalculationAlarm', NavbarCalculationAlarmComponent)
        .name;